import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';

var VerticalAlign;
(function (VerticalAlign) {
    VerticalAlign["top"] = "top";
    VerticalAlign["center"] = "center";
    VerticalAlign["bottom"] = "bottom";
})(VerticalAlign || (VerticalAlign = {}));
var DEFAULT_DENSE = false;
var DEFAULT_FIXED_WIDTH = false;
var DEFAULT_INLINE = Inline.never;
var DEFAULT_VERTICAL_ALIGN = VerticalAlign.top;
/**
 * Providence Field Group component.
 * @see {@link https://providence.fmr.com/components/field-group/field-group.html|Field Group documentation}
 */
var PvdFieldGroup = /** @class */ (function (_super) {
    __extends(PvdFieldGroup, _super);
    function PvdFieldGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDense = DEFAULT_DENSE;
        _this.pvdFixedWidth = DEFAULT_FIXED_WIDTH;
        _this.pvdInline = DEFAULT_INLINE;
        _this.pvdVerticalAlign = DEFAULT_VERTICAL_ALIGN;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdFieldGroup.prototype, "fieldGroupRole", {
        // #endregion
        // #region private methods
        get: function () {
            return this.pvdAriaLabel || this.pvdAriaLabelledby ? 'group' : undefined;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region LitElement lifecycles
    PvdFieldGroup.prototype.renderGroupLabel = function () {
        return this.isSlotUsed('group-label')
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          <div class=\"pvd-field-group__group-label\">\n            <s-slot name=\"group-label\"></s-slot>\n          </div>\n        "], ["\n          <div class=\"pvd-field-group__group-label\">\n            <s-slot name=\"group-label\"></s-slot>\n          </div>\n        "]))) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<s-slot name=\"group-label\"></s-slot>"], ["<s-slot name=\"group-label\"></s-slot>"])));
    };
    PvdFieldGroup.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-field-group-root"),
            modifierPrefix: 'pvd-field-group',
            modifiers: [
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
                {
                    condition: true,
                    className: this.pvdFixedWidth ? 'fixed-width' : 'full-width',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: 'inline',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: "inline-".concat(this.pvdInline),
                },
                {
                    condition: this.pvdVerticalAlign !== undefined,
                    className: "vertical-align-".concat(this.pvdVerticalAlign),
                },
            ],
        };
        return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n        <div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-field-group__field-group\"\n          role=\"", "\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        ", "\n        <div\n          aria-describedby=\"", "\"\n          aria-label=\"", "\"\n          aria-labelledby=\"", "\"\n          class=\"pvd-field-group__field-group\"\n          role=\"", "\"\n        >\n          <s-slot></s-slot>\n        </div>\n      </div>\n    "])), getClassName(classMap), this.renderGroupLabel(), l(this.pvdAriaDescribedby), l(this.pvdAriaLabel), l(this.pvdAriaLabelledby), l(this.fieldGroupRole));
    };
    //#region Component configuration
    PvdFieldGroup.componentName = 'field-group';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaLabel", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdAriaLabelledby", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-dense' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'))),
        __metadata("design:type", Boolean)
    ], PvdFieldGroup.prototype, "pvdDense", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-fixed-width' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-fixed-width'))),
        __metadata("design:type", Boolean)
    ], PvdFieldGroup.prototype, "pvdFixedWidth", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-inline' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdInline", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-vertical-align' }),
        __metadata("design:type", String)
    ], PvdFieldGroup.prototype, "pvdVerticalAlign", void 0);
    return PvdFieldGroup;
}(PvdSlotifyBaseComponent));
var templateObject_1, templateObject_2, templateObject_3;

export { DEFAULT_DENSE, DEFAULT_FIXED_WIDTH, DEFAULT_INLINE, DEFAULT_VERTICAL_ALIGN, PvdFieldGroup, VerticalAlign };
